 import Modal from "react-bootstrap/Modal";
 import "./BaseModal.scss";
 
 const BaseModal = ({
   show,
   onHide,
   header,
   footer,
   children,
   dialogClassName
 }) => {
   return (
     <Modal
       show={show}
       onHide={onHide}
       className="d-flex align-items-center justify-content-center"
       dialogClassName={`${dialogClassName} custom-base-modal`}
     >
       {header && (
         <Modal.Header>
           {header}
         </Modal.Header>
       )}
 
       <Modal.Body>
         {children}
       </Modal.Body>
 
       {footer && (
         <Modal.Footer>
           {footer}
         </Modal.Footer>
       )}
     </Modal>
   );
 };
 
 export default BaseModal;